import request from "../utils/request"
import { hostUrl } from "../utils/constant"

// 上传软件信息
export const uploadSoftInfo = function(params) {
  return request.post(`main/plat/v1/softmgr/uploadpic`, params);
};

export const getConfig = (params) => {
  return request.get(`main/v1/softmgr/configget`, {
    params
  });
}

export const getLastSoftInfo = (params) => {
  return request.get(`main/plat/v1/softmgr/getdetail`, {
    params
  });
}

// 软件编辑
export const saveSoftMgr = (params) => {
  return request.post(`main/plat/v1/softmgr/save`, params);
}
// 获取s3上传
export const getOssObj = (params) => {
  return request.post(`main/plat/v1/softmgr/getuploadurl`, params);
}

